<template>
  <div>
    <!-- HEADER COLONIAL MARKET -->
    <HeaderColonialMarket
      :cart-items="cartItems"
      :cart-total="cartTotal"
      :categorias="categorias"
      @search="onSearch"
      @go-cart="onGoCart"
      @go-account="onGoAccount"
      @go-orders="onGoOrders"
      @go-lists="onGoLists"
      @select-category="onSelectCategory"
      @open-delivery="onOpenDelivery"
      @go-home="onGoHome"
    />

    <!-- CONTENIDO PRINCIPAL -->
    <router-view />
  </div>
</template>

<script>
import HeaderColonialMarket from '@/components/layouts/HeaderColonialMarket.vue'

export default {
  name: 'LayoutES',
  components: { HeaderColonialMarket },

  data () {
    return {
      cartItems: 0,
      cartTotal: 0,

      // ❗ ESTE ARRAY YA NO SE USA PARA LAS CATEGORÍAS SHOPIFY,
      // porque ahora vienen dinámicas del backend.
      categorias: []
    }
  },

  methods: {
    // 🔍 Buscar productos
    onSearch (q) {
      if (!q || !q.trim()) return
      console.log('Buscar:', q)

      // FUTURO
      // this.$router.push({ name: 'SearchPage', query: { q } })
    },

    // 🛒 Carrito
    onGoCart () {
      console.log('Ir a carrito')
      // this.$router.push({ name: 'cart' })
    },

    // 👤 Cuenta
    onGoAccount () {
      console.log('Ir a cuenta / login')
      // this.$router.push({ name: 'account' })
    },

    // 📦 Pedidos
    onGoOrders () {
      console.log('Ir a pedidos')
      // this.$router.push({ name: 'orders' })
    },

    // 📄 Listas
    onGoLists () {
      console.log('Ir a listas')
      // this.$router.push({ name: 'lists' })
    },

    // 🧭 Categoría o subcategoría seleccionada
onSelectCategory(cat) {
  console.log("👉 CATEGORÍA SELECCIONADA:", cat);

  this.$router.push({
    name: "categoria-vista",
    params: {
      handle: cat.handle   // ✔ ahora coincide con la ruta
    }
  });








}


,

    // 🚚 Método de entrega
    onOpenDelivery () {
      console.log('Abrir modal método de entrega')
    },

    // 🏠 Ir a Home
    onGoHome () {
      console.log('Ir a Home')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.layout-es {
  min-height: 100vh;
}

.page-content {
  padding-top: 0; /* o lo que necesites */
}
</style>
